module.exports = __webpack_public_path__ + "img/half6.874442a.png";